import React, { useEffect, useState, useCallback } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import {FaEyeSlash } from 'react-icons/fa';
import Cookies from 'js-cookie';
import PageLoader from '../components/PageLoader';

const Disbursement = () => {
    const [disbursement, setDisbursement] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const token = Cookies.get('authToken');
    const [permissions, setPermissions] = useState([]);

    const disbursementsPerPage = 50;

    //    Pemisiion privillages atart 
    
         useEffect(() => {
                const adminId = localStorage.getItem('adminId') || '';
                axios.get(`${base_url}/api/auth/tabs/${adminId}`)
                    .then(res => setPermissions(res.data || []))
                    .catch(() => setPermissions([]));
            }, []);
        
            // Permission check helper
            const hasPermission = useCallback((tabName, action) => {
                const tab = permissions.find(t => t.tabName === tabName);
                if (!tab) return false;
                switch (action) {
                    case 'view': return !!tab.canView;
                    case 'edit': return !!tab.canEdit;
                    case 'download': return !!tab.canDelete; // using canDelete for download
                    default: return false;
                }
            }, [permissions]);


    const getAllDisbursement = useCallback(() => {
        if (!hasPermission('Disbursement', 'view')) return;
        axios.get(`${base_url}/api/account/Disbursed`, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        })
            .then((response) => {
                const sortedrepay = response.data.sort((a, b) => b.id - a.id); // Sort by ID DESC
                setDisbursement(sortedrepay); // Don't reverse again
            })
            .catch((error) => {
                console.error("Error fetching Disbursed list:", error);
            })
            .finally(() => setPageLoading(false));
    }, [token, hasPermission]);

    useEffect(() => {
        if (token) {
            getAllDisbursement();
        }
    }, [token, getAllDisbursement]);

    const handleExportDisbursement = async () => {
        if (!hasPermission('Disbursement', 'download')) {
            alert('You do not have permission to download Disbursement.');
            return;
        }
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api/export/Disbursed`, {
                responseType: 'blob',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Disbursed.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert('Disbursed List successfully');
        } catch (error) {
            console.error('Error generating Disbursed:', error.response?.data || error.message);
            alert('Export Disbursed not shown');
        } finally {
            setIsDownloading(false);
        }
    };


    const handleSearch = (event) => {
        event.preventDefault();
        if (searchOption && searchInput) {
            let url = '';
            switch (searchOption) {
                case 'borrower_name':
                    url = `${base_url}/api/customerFilter/search?borrowerName=${searchInput}`;
                    break;
                case 'borrower_id':
                    url = `${base_url}/api/customerFilter/search?customerId=${searchInput}`;
                    break;
                case 'phone':
                    url = `${base_url}/api/customerFilter/search?phone=${searchInput}`;
                    break;
                case 'panNumber':
                    url = `${base_url}/api/customerFilter/search?panNumber=${searchInput}`;
                    break;
                case 'loanId':
                    url = `${base_url}/api/customerFilter/search?loanId=${searchInput}`;
                    break;
                default: break;
            }
            axios.get(url).then(
                (response) => {
                    setDisbursement(response.data);
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };


    const indexOfLastDisbursement = currentPage * disbursementsPerPage;
    const indexOfFirstDisbursement = indexOfLastDisbursement - disbursementsPerPage;
    const disbursements = disbursement.slice(indexOfFirstDisbursement, indexOfLastDisbursement);
    const totalPages = Math.ceil(disbursement.length / disbursementsPerPage);
    const maxPageButtons = 10;

    const getPaginationRange = () => {
        const mid = Math.floor(maxPageButtons / 2);
        let start = Math.max(1, currentPage - mid);
        let end = Math.min(totalPages, start + maxPageButtons - 1);
        if (end - start < maxPageButtons - 1) start = Math.max(1, end - maxPageButtons + 1);
        return { start, end };
    };

    const { start: startPage, end: endPage } = getPaginationRange();

    if (!hasPermission('Disbursement', 'view')) {
        return (
            <div className="text-center mt-5">
                <h3>Access Denied</h3>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }


    return (
        <>
            <div className='overviewsaa'>
                <h4>Disbursement Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form onSubmit={handleSearch}>
                                            <div className='row'>
                                                <div className="col-md-3 col-3">
                                                    <div className=" required">
                                                         <select className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required>
                                                        <option value="">Search By</option>
                                                        <option value="borrower_name">Borrower Name</option>
                                                        <option value="borrower_id">Customer Id</option>
                                                        <option value="phone">Phone</option>
                                                        <option value="panNumber">Pan Number</option>
                                                        <option value="loanId">Loan Id</option>
                                                    </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-3">
                                                    <div className=" required">
                                                        <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required />
                                                    </div>
                                                </div>
                                                <div className="col-md-2 col-3">
                                                    <div className=" required iconsss">
                                                        <button type="submit" className="btn btn-sm btn-primary">Search</button>
                                                    </div>
                                                </div>
                                                <div className="col-md-2 mt-2">
                                                    <div className='resion'>
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportDisbursement}
                                                        disabled={isDownloading || !hasPermission('Disbursement', 'download')}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>Download</>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='allcustomer table-responsive table-striped mt-3'>
                                        { pageLoading ? <PageLoader text="Loading..." /> : disbursement.length > 0  ? (
                                            <table className="styled-table">
                                                <thead>
                                                    <tr>
                                                        <th>S.N</th>
                                                        <th>Customer_Id</th>
                                                        <th>Agent_Id</th>
                                                        <th>Branch_Name</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Mobile_Number</th>
                                                        <th>Pan_Number</th>
                                                        <th>Date_of_Birth</th>
                                                        <th>Create_Date</th>
                                                        <th>Update_Date</th>
                                                        <th>Disbursal_Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {disbursements.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{index+1}</td>
                                                            <td>{data.id}</td>
                                                            <td>{data.employeeId}</td>
                                                            <td>{data.branch}</td>
                                                            <td>{data.borrowerName}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.panNumber}</td>
                                                            <td>{data.dob}</td>
                                                            <td>{data.createDate ? new Date(data.createDate).toLocaleDateString() : ''}</td>
                                                            <td>{data.updateDate ? new Date(data.updateDate).toLocaleDateString() : ''}</td>
                                                            {/* <td>{data.emiStatus === 0 ? 'Pending' : data.emiStatus === 1 ? 'Paid' : 'Unknown'}</td> */}
                                                            <td style={{ color: data.status === 1 ? 'green' : data.status === 0 ? 'black' : 'red', fontWeight: '700' }}>{data.status === 0 ? 'Pending' : data.status === 1 ? 'Loan_Disbursed' : 'Unknown'}</td>
                                                            <td className='iconss'>
                                                                 {hasPermission('Disbursement', 'view') ? (
                                                                <NavLink to={`/operation/ViewVerifiedCustomer?id=${data.id}`}>
                                                                    <FaEyeSlash />
                                                                </NavLink>
                                                                  ) : (
                                                                 <FaEyeSlash style={{ opacity: 0.3, cursor: 'not-allowed' }} title="No permission" />
                                                                 )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        ) : (
                                            "No Disbursement"
                                        )}
                                    </div>

                                    <div className="pagination-container">
                                        <div className="pagination-box">
                                            {startPage > 1 && (
                                                <>
                                                    <button onClick={() => setCurrentPage(1)}>1</button>
                                                    <span className="dots">...</span>
                                                </>
                                            )}
                                            {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                                                <button
                                                    key={startPage + i}
                                                    className={currentPage === startPage + i ? 'active' : ''}
                                                    onClick={() => setCurrentPage(startPage + i)}
                                                >
                                                    {startPage + i}
                                                </button>
                                            ))}
                                            {endPage < totalPages && (
                                                <>
                                                    <span className="dots">...</span>
                                                    <button onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>
                                                </>
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Disbursement;
